import {
  collectionToArrayCommonImplq0mfhcp9jn08 as collectionToArrayCommonImpl,
  throwIndexOverflow28kwzhaoae5ib as throwIndexOverflow,
  throwCountOverflow18of2v929seka as throwCountOverflow,
} from './CollectionsKt.mjs';
import { hashMapOf2phwdlwszpif7 as hashMapOf } from './Maps.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from './ArrayListJs.mjs';
import { hashSetOf1p9d9akkobppk as hashSetOf } from './Sets.mjs';
import {
  toMutableListoiy7juhbnlr7 as toMutableList,
  shuffle28202iiliqd4i as shuffle,
} from './_Collections.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../Unit.mjs';
import { naturalOrder3459ca049ngp6 as naturalOrder } from '../comparisons/Comparisons.mjs';
import { Default_getInstance3u4i6y54ri5cn as Default_getInstance } from '../random/Random.mjs';
import { sortArrayWith2peqe6a4xxbw8 as sortArrayWith } from './ArraySorting.mjs';
import { Companion_instanceovl8he3jiijf as Companion_instance } from './AbstractList.mjs';
//region block: imports
var isView = ArrayBuffer.isView;
//endregion
//region block: pre-declaration
//endregion
function collectionToArray(collection) {
  return collectionToArrayCommonImpl(collection);
}
function terminateCollectionToArray(collectionSize, array) {
  return array;
}
function arrayOfNulls(reference, size) {
  // Inline function 'kotlin.arrayOfNulls' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return Array(size);
}
function mapOf(pair) {
  return hashMapOf([pair]);
}
function listOf(element) {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [element];
  return ArrayList().s5(tmp$ret$2);
}
function setOf(element) {
  return hashSetOf([element]);
}
function shuffled(_this__u8e3s4) {
  // Inline function 'kotlin.apply' call
  var this_0 = toMutableList(_this__u8e3s4);
  shuffle_0(this_0);
  return this_0;
}
function mapCapacity(expectedSize) {
  return expectedSize;
}
function checkIndexOverflow(index) {
  if (index < 0) {
    throwIndexOverflow();
  }
  return index;
}
function sortWith(_this__u8e3s4, comparator) {
  collectionsSort(_this__u8e3s4, comparator);
}
function checkCountOverflow(count) {
  if (count < 0) {
    throwCountOverflow();
  }
  return count;
}
function sort(_this__u8e3s4) {
  collectionsSort(_this__u8e3s4, naturalOrder());
}
function copyToArray(collection) {
  var tmp;
  // Inline function 'kotlin.js.asDynamic' call
  if (collection.toArray !== undefined) {
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.unsafeCast' call
    tmp = collection.toArray();
  } else {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp = collectionToArray(collection);
  }
  return tmp;
}
function shuffle_0(_this__u8e3s4) {
  return shuffle(_this__u8e3s4, Default_getInstance());
}
function collectionsSort(list, comparator) {
  if (list.p1() <= 1)
    return Unit_instance;
  var array = copyToArray(list);
  sortArrayWith(array, comparator);
  var inductionVariable = 0;
  var last = array.length;
  if (inductionVariable < last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      list.b2(i, array[i]);
    }
     while (inductionVariable < last);
}
function arrayCopy(source, destination, destinationOffset, startIndex, endIndex) {
  Companion_instance.r5(startIndex, endIndex, source.length);
  var rangeSize = endIndex - startIndex | 0;
  Companion_instance.r5(destinationOffset, destinationOffset + rangeSize | 0, destination.length);
  if (isView(destination) && isView(source)) {
    // Inline function 'kotlin.js.asDynamic' call
    var subrange = source.subarray(startIndex, endIndex);
    // Inline function 'kotlin.js.asDynamic' call
    destination.set(subrange, destinationOffset);
  } else {
    if (!(source === destination) || destinationOffset <= startIndex) {
      var inductionVariable = 0;
      if (inductionVariable < rangeSize)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          destination[destinationOffset + index | 0] = source[startIndex + index | 0];
        }
         while (inductionVariable < rangeSize);
    } else {
      var inductionVariable_0 = rangeSize - 1 | 0;
      if (0 <= inductionVariable_0)
        do {
          var index_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + -1 | 0;
          destination[destinationOffset + index_0 | 0] = source[startIndex + index_0 | 0];
        }
         while (0 <= inductionVariable_0);
    }
  }
}
//region block: exports
export {
  arrayCopy as arrayCopytctsywo3h7gj,
  arrayOfNulls as arrayOfNulls3cqbl98qmfq5b,
  checkCountOverflow as checkCountOverflow1ro2fe1r4xvgf,
  checkIndexOverflow as checkIndexOverflow3frtmheghr0th,
  collectionToArray as collectionToArray1y0om6a7tdy9a,
  copyToArray as copyToArray2j022khrow2yi,
  listOf as listOfvhqybd2zx248,
  mapCapacity as mapCapacity1h45rc3eh9p2l,
  mapOf as mapOf2zpbbmyqk8xpf,
  setOf as setOf1u3mizs95ngxo,
  shuffled as shuffled357jrbcm2hlkc,
  sortWith as sortWith4fnm6b3vw03s,
  sort as sort15ai02l4kxbfa,
  terminateCollectionToArray as terminateCollectionToArray12671uhv05xea,
};
//endregion

//# sourceMappingURL=collectionJs.mjs.map
